import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "@tsp-core/store/utils";

import { DepartmentsDictionary, DepartmentsDictionaryRecord } from "../types";

type GetDepartmentsResponseData = {
  departments: Array<DepartmentsDictionaryRecord>;
};

export const departmentsApi = createApi({
  reducerPath: "@departments/api",
  baseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: false,
  keepUnusedDataFor: 60 * 60 * 24,
  endpoints: (builder) => ({
    getDepartmentsDictionary: builder.query<DepartmentsDictionary, void>({
      query: () => ({
        url: "/getDepartments",
        method: "GET",
      }),
      transformResponse: (response: GetDepartmentsResponseData) => {
        return response.departments.reduce((accumulator, item) => {
          const name = item.name || "No name";
          const postfix = item.isArchived ? " (Archived)" : "";

          accumulator[item.uuid] = {
            uuid: item.uuid,
            name: `${name}${postfix}`,
            isArchived: item.isArchived,
          };
          return accumulator;
        }, {} as DepartmentsDictionary);
      },
    }),
  }),
});
